"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useCustomRequest = _interopRequireDefault(require("../../utils/useCustomRequest"));

require("./style.less");

var _antd = require("antd");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//const NO_OP = () => {};
var NO_OP = function NO_OP() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }

  console.log('UploadButton', a);
}; // NOTICE: This component hides the (ugly) logic of uploading via a multipart
//         form in our app


var UploadButton = function UploadButton(_ref) {
  var intl = _ref.intl,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      actionUrl = _ref.actionUrl,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? NO_OP : _ref$onSuccess,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? NO_OP : _ref$onError,
      _ref$authenticated = _ref.authenticated,
      authenticated = _ref$authenticated === void 0 ? false : _ref$authenticated,
      accept = _ref.accept,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      component = _ref.component,
      _ref$section = _ref.section,
      section = _ref$section === void 0 ? 'initiative_documents' : _ref$section,
      api_requests = _ref.api_requests,
      refreshAccessToken = _ref.refreshAccessToken;
  var t = intl.messages;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var customRequest = (0, _useCustomRequest.default)({
    api_requests: api_requests,
    refreshAccessToken: refreshAccessToken,
    onSuccess: onSuccess,
    onError: onError
  }, [api_requests, refreshAccessToken, onSuccess, onError]);
  var handleChange = (0, _react.useCallback)(function (_ref2) {
    var file = _ref2.file;

    switch ((file || {}).status) {
      case 'error':
        setError(true);
        setLoading(false);
        break;

      case 'done':
        setError(false);
        setLoading(false);
        break;

      case 'uploading':
        setError(false);
        setLoading(true);
        break;

      default:
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Upload, _extends({
    showUploadList: false,
    action: actionUrl,
    disabled: loading,
    className: "UploadButton ".concat(className)
  }, accept && {
    accept: accept
  }, !authenticated ? {} : {
    customRequest: customRequest,
    headers: {
      'Authorization': "Bearer ".concat(api_requests.access_token)
    }
  }, {
    customRequest: customRequest,
    onChange: handleChange
  }), component || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "UploadButton__content"
  }, loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    size: "large"
  }) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: "file-upload",
    size: "2x",
    color: "white"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "UploadButton__upload-text"
  }, t["".concat(section, "_upload_button")])), /*#__PURE__*/_react.default.createElement("p", {
    className: "UploadButton__upload-subtext"
  }, loading ? t["".concat(section, "_upload_loading")] : error ? t["".concat(section, "_upload_error")] : children))));
};

var _default = UploadButton;
exports.default = _default;